<template>
    <div class="echart-line"  ref="echartsLineRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import {getHomeStaticLine} from "@/apis/public";
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
export default {
    name: 'EchartLine',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            date : "",
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['项目回款', '项目支出', '开票金额']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        rotate: 30 // 旋转45度
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '项目回款',
                        type: 'line',
                        stack: 'Total',
                        data: []
                    },
                    {
                        name: '项目支出',
                        type: 'line',
                        stack: 'Total',
                        data: []
                    },
                    {
                        name: '开票金额',
                        type: 'line',
                        stack: 'Total',
                        data: []
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.getLineEchart();
        })
    },
    methods:{
      getLineEchart(){
        let that = this;
        getHomeStaticLine().then(e=>{
          let re = e.data;
          const chartDom = this.$refs.echartsLineRef;
          echarts.registerTheme('macarons', macarons);
          const myChart = echarts.init(chartDom, macarons);
          that.option.xAxis.data = re.date;
          that.option.series[0].data = re.income_money;
          that.option.series[1].data = re.expend_money;
          that.option.series[2].data = re.invoice_money;
          myChart.setOption(that.option);
        })
      },
      getLineEcharts(){
            console.log(this.search)
            const chartDom = this.$refs.echartsLineRef;
            echarts.registerTheme('macarons', macarons);
            const myChart = echarts.init(chartDom, macarons);
            myChart.setOption(this.option);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
